export default __webpack_public_path__ + "ba6e7528ca3a0269c0af94b0fab4eea8.svg";